// The 11-character video id from any common YouTube link: watch?v= (wherever v sits in the query),
// youtu.be/, /shorts/, /live/, /embed/ and /v/, on www, m. and music. hosts and youtube-nocookie.com.
// Anything else (including a bare id) returns null, so pasted text only counts when it's a link.
const LINK = /(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/(?:watch\?(?:[^#\s]*&)?v=|embed\/|v\/|shorts\/|live\/))([\w-]{11})(?![\w-])/i;

export const extractYouTubeVideoId = text => {
  const match = String(text || '').match(LINK);
  return match ? match[1] : null;
};
